import React from 'react';

interface ContactSectionProps {
  title: string;
  description: string;
  buttonText: string;
  onContactClick?: () => void;
}

const ContactSection: React.FC<ContactSectionProps> = ({
  title,
  description,
  buttonText,
  onContactClick,
}) => {
  return (
    <div className="bg-gradient-to-r from-orange-500/20 to-purple-500/20 rounded-xl 
                    border border-orange-500/30 p-11">
      <div className="flex flex-col items-center gap-12">
        <h2 className="text-white text-3xl font-normal text-center">
          {title}
        </h2>
        
        <p className="text-white/70 text-xl text-center max-w-2xl">
          {description}
        </p>
        
        <button
          onClick={onContactClick}
          className="px-5 py-2.5 bg-orange-500 rounded-xl hover:bg-orange-600 
                   transition-colors duration-200"
        >
          <span className="text-white text-lg font-medium">
            {buttonText}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ContactSection;